import React from 'react';
import { observer } from 'mobx-react-lite';

export type SymbolDetailLabeledValueType = {
    label: React.ReactNode;
    value: React.ReactNode;
};

export const SymbolDetailLabeledValue: React.FC<SymbolDetailLabeledValueType> = observer(
    ({ label, value }: SymbolDetailLabeledValueType) => {
        return (
            <div className="flex items-center justify-between gap-xsmall text-vsmall leading-vsmall lg:text-medium lg:leading-medium">
                <div>{label}</div>
                <div className="font-semibold text-brand-secondary">{value}</div>
            </div>
        );
    },
);
